import { registerSlot } from '@/lib/slots';
import type { ClientArea } from '../types';
import { CommentsSlot } from './Comments';
import { RecordSheetSlot } from './RecordSheet';

export const area: ClientArea = {
  name: 'record',
  setup() {
    registerSlot('record.sheet', RecordSheetSlot);
    registerSlot('comments', CommentsSlot);
  },
};
